import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import InquiryModal from '../components/InquiryModal'

export default function ProcessPage() {
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    document.title = 'Processen - SKI & CO TRAVEL ApS'
  }, [])

  const procesSteps = [
    {
      nummer: '01',
      titel: 'Behovsafklaring',
      beskrivelse: 'Vi afstemmer formål, budget og antal deltagere. Vi lytter til jeres ønsker for fagligt indhold, netværk og de sociale rammer.',
      icon: 'fa-comments',
    },
    {
      nummer: '02',
      titel: 'Skræddersyet program',
      beskrivelse: 'I vælger indhold og prioriteringer — vi sætter det sammen. Alt fra transport og hoteller til mødelokaler, pister og restauranter.',
      icon: 'fa-sliders',
    },
    {
      nummer: '03',
      titel: 'Gennemførelse',
      beskrivelse: 'Vi er med hele vejen, så I kan fokusere på jeres gæster. Vi håndterer logistikken og sikrer, at turen forløber ubesværet.',
      icon: 'fa-circle-check',
    },
    {
      nummer: '04',
      titel: 'Opfølgning',
      beskrivelse: 'Evaluering og inspiration til næste arrangement. Vi samler op på turen og sikrer, at alle mål med arrangementet blev nået.',
      icon: 'fa-chart-pie',
    },
  ]

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 space-y-16">
      {/* Header */}
      <div className="space-y-4 max-w-3xl">
        <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">
          PROCESSEN
        </span>
        <h1 className="font-heading font-extrabold text-2xl sm:text-4xl text-white">
          Fra idé til afgang
        </h1>
        <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
          Vi tager hånd om hele forløbet, så I kan fokusere på relationerne og det faglige udbytte. Her er de fire enkle trin i vores samarbejde.
        </p>
      </div>

      {/* Steps Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {procesSteps.map((step) => (
          <div
            key={step.nummer}
            className="bg-slate-900 border border-slate-800 rounded-3xl p-8 space-y-4 shadow-xl hover:border-cyan-500/40 transition-all relative overflow-hidden"
          >
            <div className="flex items-center justify-between">
              <span className="font-heading font-black text-4xl text-cyan-400">
                {step.nummer}
              </span>
              <div className="w-12 h-12 rounded-2xl bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 flex items-center justify-center text-xl">
                <i className={`fa-solid ${step.icon}`} aria-hidden="true" />
              </div>
            </div>

            <h2 className="font-heading font-bold text-2xl text-white">
              {step.titel}
            </h2>

            <p className="text-slate-300 text-sm leading-relaxed">
              {step.beskrivelse}
            </p>
          </div>
        ))}
      </div>

      {/* Trust & Guarantees section */}
      <div className="bg-gradient-to-r from-slate-900 via-slate-900 to-cyan-950/40 border border-slate-800 rounded-3xl p-8 sm:p-12 space-y-8 shadow-2xl">
        <div className="max-w-3xl space-y-3">
          <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">
            TRYGHED & KVALITET
          </span>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl text-white">
            Personlig service og 25+ års erfaring
          </h2>
          <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
            Når I samarbejder med Ski & Co Travel, får I direkte rådgivning fra Claus Nexø Hansen. Med mere end 25 års ski-erfaring og mangeårig baggrund som salgsdirektør ved vi præcis, hvad der kræves af et vellykket erhvervsarrangement.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-4">
          <button
            onClick={() => setModalOpen(true)}
            className="px-6 py-3.5 rounded-xl bg-cyan-400 hover:bg-cyan-300 text-slate-950 font-bold text-sm transition-colors shadow-lg shadow-cyan-400/20"
          >
            Start samtalen &rarr;
          </button>
          <Link
            to="/kontakt"
            className="px-6 py-3.5 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm transition-colors border border-slate-700"
          >
            Se kontaktoplysninger
          </Link>
        </div>
      </div>

      <InquiryModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  )
}
